import React from "react";
import { db } from "~db/db";
import { slug } from "~services/GlobalServices";

const useUpdateData = ({ updateHook, table = db.funilObraNaoSalvo, clienteId, setModalMessage, dashFilterGanha }) => {
  
  const handleVolumeUpdate = async ({ev, header}) => {
    const value = isNaN(parseInt(ev.target.value)) ? 0 : parseInt(ev.target.value);

    if(!value || value == 0){
      setModalMessage({
        message: "Não é permitido a inserção de volume zerado", 
        submessage: "Insira um valor válido", 
        status: "warning"
      });
      updateHook();
      return;
    }

    let data = await table.where('id').equals(header.id).first();
    if(data){
      data.volumeEstimado = value;
      await table.put(data);
      updateHook();
    }
  
    // if (e.target.value < 1000) setShowVolumeUpdateModal(true);
  };
  
  const handleNegociacaoUpdate = async ({ev, header}) => {
    
    const value = ev.target.value;
    
    if(validateDate({value})){
      updateHook();
      return;
    }

    let data = await table.where('id').equals(header.id).first();
    if(data){
      data.dataNegociacao = ev.target.value;
      await table.put(data);
      updateHook();
    }
  }
  
  const handleUpdateAllData = async ({ev, header}) => {
    const novaData = (ev.target.value || "").trim();
    const old = header.dataNegociacao;

    if(novaData == old) return;

    if(validateDate({value: novaData})){
      updateHook();
      return;
    }
  
    if(novaData){
      let data = [];
      if(clienteId){
        const item = await table.where('id').equals(header.id).first();
        if(item){
          const id = item.clienteId;
          if(id) await table.filter(e => e.clienteId == id && e.dataNegociacao == old).each(e => data.push(e));
        }
      }else{
        await table.where('dataNegociacao').equals(old)
        .and(e => typeof dashFilterGanha == "function" ? dashFilterGanha(e) : true && e.dataNegociacao == old)
        .each(e => data.push(e));
      }

      if(data?.length){
        data = data.map(el => ({
          ...el,
          dataNegociacao: novaData
        }))

        if(data?.length){
          table.bulkPut(data).then(() => {
            updateHook()
          });
        }else{
          updateHook();
        }
      }
    }
  }
  
  const handleUpdateAllEtapa = async ({ev, header}) => {
    const novaEtapa = (ev.target.value || "").trim();
    const old = header.etapa;

    if(!novaEtapa || novaEtapa.length == 0){
      setModalMessage({
        message: "Etapa inválida. Não são permitidos valores vazios.", 
        submessage: "Insira uma etapa válida", 
        status: "warning"
      });

      updateHook();
      return;
    }

    const oldSlug = slug(old);
  
    if(novaEtapa){
      let data = await table.where('id').equals(header.id).first();
      if(data){
        const clienteId = data.clienteId;
  
        table.where("clienteId").equals(clienteId).toArray().then(data => {
          let toUpdate = [];
          data.forEach(el => {
            if(oldSlug == slug(el.etapa)){
              toUpdate.push({
                ...el,
                etapa: novaEtapa
              });
            }
          })
  
          if(toUpdate?.length){
            table.bulkPut(toUpdate).then(() => {
              updateHook()
            });
          }else{
            updateHook();
          }
        })
      }
    }
  }

  const handleDelete = async ({grupo, etapa, etapaSlug, deleteBy = [], id}) => {
    deleteBy = Array.isArray(deleteBy) ? deleteBy : [];

    let data = [];
    let query = await table;

    query.filter(el => 
        (clienteId ? el.clienteId == parseInt(clienteId) : true) &&
        (deleteBy.includes("grupo") ? grupo == el.funilObraGrupoProdutoId : true) && 
        (deleteBy.includes("etapa") ? etapa == el.etapa : true) && 
        (deleteBy.includes("etapaSlug") ? etapaSlug == el.etapaSlug : true) && 
        (deleteBy.includes("id") ? id == el.id : true)
    )
    .each(e => data.push(e.id)).then(e => {
      if(data.length > 0)
      return table.bulkDelete(data);
    })
    .then(() => {
      updateHook();
    })
  };

  const validateDate = ({value}) => {
    let showModal = false;
    let message = "Digite a data corretamente.";

    if(!value){
      showModal = true;   
    }
    else{
      const date = new Date(`${value}T00:00:00`);
      date.setHours(0, 0, 0, 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if(date < today){
        showModal = true;
        message = "Apenas datas de negociação posteriores à data atual são aceitas";
      }
    }

    if(showModal){
      setModalMessage({
        message, 
        submessage: "Insira uma data válida", 
        status: "warning"
      });
    }

    return showModal;
  }

  return {
    handleVolumeUpdate,
    handleNegociacaoUpdate,
    handleUpdateAllData,
    handleUpdateAllEtapa,
    handleDelete
  }
}

export default useUpdateData;